import { render } from "./TablaCreditosMora.vue?vue&type=template&id=6dcc23aa"
import script from "./TablaCreditosMora.vue?vue&type=script&lang=js"
export * from "./TablaCreditosMora.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__